module.exports = __webpack_public_path__ + "img/register_external_bg.f4bab37a.png";